import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logOut } from "../../helpers/configRoutes/backend_helper";

const Header = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.Login.user);
  const [menuItems, setMenuItems] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (user?.id) {
      setMenuItems(user.models || []);
    }
  }, [user]);

  useEffect(() => {
    setIsMenuOpen(false);
    setIsProfileMenuOpen(false);
  }, [location]);

  const handleLogout = async () => {
    await logOut();
    localStorage.clear();
    navigate('/login');
  };

  return (
    <header className="relative flex items-center justify-between h-16 px-4 bg-cs-surface border-b border-cs-border">
      
      {/* Left: Logo + menu button */}
      <div className="flex items-center gap-3">
        {/* Mobile menu */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="lg:hidden text-cs-dark"
        >
          <span className="material-symbols-outlined">menu</span>
        </button>

        {/* Logo */}
        <div className="flex items-center gap-2">
          <img
            src="/images/logoA.png" // ajusta ruta
            alt="Logo"
            className="h-24 object-contain"
          />
        </div>
      </div>

      {/* Right: User profile */}
      <div className="relative">
        <button
          onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
          className="flex items-center gap-3 text-left"
        >
          <img
            src={user.imageProfile || "/images/usrAnonimo.png"}
            alt="Profile"
            className="w-9 h-9 rounded-full border border-cs-border"
          />
          <div className="hidden md:block">
            <p className="text-sm font-medium text-cs-dark">
              {user.first_name}
            </p>
            <p className="text-xs text-cs-muted">
              {user.role}
            </p>
          </div>
          <span
            className={`material-symbols-outlined text-cs-muted transition-transform ${
              isProfileMenuOpen ? 'rotate-180' : ''
            }`}
          >
            expand_more
          </span>
        </button>

        {/* Profile dropdown */}
        {isProfileMenuOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-cs-surface border border-cs-border rounded-lg shadow-sm overflow-hidden z-50">
            <Link
              to="/profile"
              className="block px-4 py-2 text-sm text-cs-dark hover:bg-cs-bg-alt"
            >
              Perfil
            </Link>
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 text-sm text-cs-danger hover:bg-cs-danger-soft"
            >
              Cerrar sesión
            </button>
          </div>
        )}
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <nav className="absolute top-full left-0 w-full bg-cs-surface border-t border-cs-border lg:hidden z-40">
          {menuItems.map((item, index) => {
            const isActive =
              location.pathname === item.link ||
              item.associatedRoutes?.includes(location.pathname);

            return (
              <Link
                key={index}
                to={item.link}
                className={`flex items-center gap-3 px-4 py-3 text-sm transition-colors
                  ${isActive
                    ? 'bg-cs-primary-soft text-cs-primary border-l-4 border-cs-primary'
                    : 'text-cs-dark hover:bg-cs-bg-alt'
                  }`}
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="material-symbols-outlined text-base">
                  {item.icon}
                </span>
                {item.name}
              </Link>
            );
          })}
        </nav>
      )}
    </header>
  );
};

export default Header;
